/** 区分业务线标识
 * https://joyspace.jd.com/pages/zd8DOjzkf61TjNlPOvnP
 */
export const ASSET_TYPE = {
  shangYeZiChan: 8, // 商业资产
  jinRongZiChan: 7, // 金融资产
  guoYouZiChan: 1, // 国有资产
  haiGuanFaMo: 11, // 海关罚没
  zhengFuGuoZi: 12, // 政府国资
}

export const HOME_PAGE_URL = {
  paimaiHome: '//pro.m.jd.com/mall/active/Z18bTFRhFkX996GfMRGfJuUXXRJ/index.html?mTabId=244pVabo1RL3DZeDTJKG3tdHwfKp',
  shangYeZiChan: '//pro.m.jd.com/mall/active/2u6TFPUW9JGjcJWspEccmnw1t6en/index.html?mTabId=244pVabo1RL3DZeDTJKG3tdHwfKp',
  jinRongZiChan: '//pro.m.jd.com/mall/active/47aLMzuFidsEiKoc8EFCoZy16728/index.html?mTabId=244pVabo1RL3DZeDTJKG3tdHwfKp',
  guoYouZiChan: '//pro.m.jd.com/mall/active/4D4tf1RhsQ7onHfw7Rw7wLKuusiS/index.html?mTabId=244pVabo1RL3DZeDTJKG3tdHwfKp',
  haiGuanFaMo: '//pro.m.jd.com/mall/active/47i65W71rBeQ8JsHMi4xDzMtDYaE/index.html?mTabId=244pVabo1RL3DZeDTJKG3tdHwfKp',
  zhengFuGuoZi: '//pro.m.jd.com/mall/active/4D4tf1RhsQ7onHfw7Rw7wLKuusiS/index.html?mTabId=244pVabo1RL3DZeDTJKG3tdHwfKp',
}
